import { render, staticRenderFns } from "./FormNews.vue?vue&type=template&id=8070f9f8&"
import script from "./FormNews.vue?vue&type=script&lang=js&"
export * from "./FormNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports